/*!
 * @pixi/filter-alpha - v7.0.0-alpha
 * Compiled Fri, 09 Sep 2022 16:09:18 UTC
 *
 * @pixi/filter-alpha is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import{Filter as a,defaultVertex as e}from"@pixi/core";var t=`varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float uAlpha;

void main(void)
{
   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;
}
`;class l extends a{constructor(r=1){super(e,t,{uAlpha:1}),this.alpha=r}get alpha(){return this.uniforms.uAlpha}set alpha(r){this.uniforms.uAlpha=r}}export{l as AlphaFilter};
//# sourceMappingURL=filter-alpha.min.mjs.map
